import { useCallback, useEffect, useState } from 'react';

/**
 * The current time, re-read every `intervalMs` (a minute by default), for countdowns and time-based labels. `refresh`
 * re-reads it on demand, e.g. when new data arrives so the labels match it.
 */
export function useNow(intervalMs = 60000): [Date, () => void] {
  const [now, setNow] = useState(() => new Date());
  const refresh = useCallback(() => setNow(new Date()), []);

  useEffect(() => {
    const id = window.setInterval(refresh, intervalMs);

    return () => window.clearInterval(id);
  }, [intervalMs, refresh]);

  return [now, refresh];
}
